import { PlacementType } from '../types/product.types';

export const PLACEMENT_TYPES: { label: string; value: PlacementType }[] = [
  { label: 'Floor', value: 'floor' },
  { label: 'Wall', value: 'wall' },
  { label: 'Face Accessory', value: 'face_accessory' },
  { label: 'Hand', value: 'hand' },
  { label: 'Foot / Shoe (Preview)', value: 'foot' },
];

export const FACE_ACCESSORY_SUBTYPES: { label: string; value: string; hint: string }[] = [
  { label: 'Glasses', value: 'glasses', hint: 'Anchors between eyes on nose bridge' },
  { label: 'Earrings (pair)', value: 'earrings', hint: 'Anchors on both ears simultaneously' },
  { label: 'Necklace', value: 'necklace', hint: 'Anchors below chin / neck area' },
  { label: 'Hat / Cap', value: 'hat', hint: 'Anchors on top of forehead' },
  { label: 'Nose Ring', value: 'nose_ring', hint: 'Anchors on nose tip' },
  { label: 'Bindi / Forehead', value: 'bindi', hint: 'Anchors on center forehead' },
];

export const HAND_ACCESSORY_SUBTYPES: { label: string; value: string; hint: string }[] = [
  { label: 'Bracelet', value: 'bracelet', hint: 'Anchors on the wrist' },
  { label: 'Ring', value: 'ring', hint: 'Anchors on a finger — tap to switch fingers' },
  { label: 'Watch / Clock', value: 'watch', hint: 'Anchors on the wrist with dial oriented to top hand surface' },
];

export const FOOT_ACCESSORY_SUBTYPES: { label: string; value: string; hint: string }[] = [
  { label: 'Shoe', value: 'shoe', hint: 'Pose-based ankle and toe anchors (preview quality)' },
];

export const ASSET_STATUS_LABELS: Record<string, string> = {
  none: 'No AR Model',
  pending: 'Pending',
  processing: 'Processing',
  ready: 'Ready',
  failed: 'Failed',
};

export const ASSET_STATUS_COLORS: Record<string, 'success' | 'warning' | 'critical' | 'info'> = {
  none: 'info',
  pending: 'warning',
  processing: 'warning',
  ready: 'success',
  failed: 'critical',
};
